import DisplayAd from '@/components/Advertising/Ada/Ada'

type WidgetAdSlotAdaProps = {
  readonly model: {
    readonly fields: {
      readonly name: string
      readonly position: number
    }
  }
}

const Adslot = ({ item }: { item: WidgetAdSlotAdaProps }) => {
  if (!(item.model.fields.name && item.model.fields.position)) {
    return <></>
  }
  const { name, position } = item.model.fields
  return <DisplayAd name={name} position={position} />
}

export default Adslot
